import _classCallCheck from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Util } from './Util.js';
import { Container } from './Container.js';
import { Node } from './Node.js';
import { Factory } from './Factory.js';
import { SceneCanvas, HitCanvas } from './Canvas.js';
import { getBooleanValidator } from './Validators.js';
import { shapes } from './Shape.js';
import { _registerNode } from './Global.js';
var HASH = '#',
    BEFORE_DRAW = 'beforeDraw',
    DRAW = 'draw',
    INTERSECTION_OFFSETS = [{
  x: 0,
  y: 0
}, {
  x: -1,
  y: -1
}, {
  x: 1,
  y: -1
}, {
  x: 1,
  y: 1
}, {
  x: -1,
  y: 1
}],
    INTERSECTION_OFFSETS_LEN = INTERSECTION_OFFSETS.length;
export var Layer =
/*#__PURE__*/
function (_Container) {
  _inherits(Layer, _Container);

  function Layer(config) {
    var _this;

    _classCallCheck(this, Layer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Layer).call(this, config));
    _this.canvas = new SceneCanvas();
    _this.hitCanvas = new HitCanvas({
      pixelRatio: 1
    });
    _this._waitingForDraw = false;

    _this.on('visibleChange.konva', _this._checkVisibility);

    _this._checkVisibility();

    _this.on('imageSmoothingEnabledChange.konva', _this._setSmoothEnabled);

    _this._setSmoothEnabled();

    return _this;
  }

  _createClass(Layer, [{
    key: "createPNGStream",
    value: function createPNGStream() {
      var c = this.canvas._canvas;
      return c.createPNGStream();
    }
  }, {
    key: "getCanvas",
    value: function getCanvas() {
      return this.canvas;
    }
  }, {
    key: "getNativeCanvasElement",
    value: function getNativeCanvasElement() {
      return this.canvas._canvas;
    }
  }, {
    key: "getHitCanvas",
    value: function getHitCanvas() {
      return this.hitCanvas;
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.getCanvas().getContext();
    }
  }, {
    key: "clear",
    value: function clear(bounds) {
      this.getContext().clear(bounds);
      this.getHitCanvas().getContext().clear(bounds);
      return this;
    }
  }, {
    key: "setZIndex",
    value: function setZIndex(index) {
      _get(_getPrototypeOf(Layer.prototype), "setZIndex", this).call(this, index);

      var stage = this.getStage();

      if (stage && stage.content) {
        stage.content.removeChild(this.getNativeCanvasElement());

        if (index < stage.children.length - 1) {
          stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
        } else {
          stage.content.appendChild(this.getNativeCanvasElement());
        }
      }

      return this;
    }
  }, {
    key: "moveToTop",
    value: function moveToTop() {
      Node.prototype.moveToTop.call(this);
      var stage = this.getStage();

      if (stage && stage.content) {
        stage.content.removeChild(this.getNativeCanvasElement());
        stage.content.appendChild(this.getNativeCanvasElement());
      }

      return true;
    }
  }, {
    key: "moveUp",
    value: function moveUp() {
      var moved = Node.prototype.moveUp.call(this);

      if (!moved) {
        return false;
      }

      var stage = this.getStage();

      if (!stage || !stage.content) {
        return false;
      }

      stage.content.removeChild(this.getNativeCanvasElement());

      if (this.index < stage.children.length - 1) {
        stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
      } else {
        stage.content.appendChild(this.getNativeCanvasElement());
      }

      return true;
    }
  }, {
    key: "moveDown",
    value: function moveDown() {
      if (Node.prototype.moveDown.call(this)) {
        var stage = this.getStage();

        if (stage) {
          var children = stage.children;

          if (stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
          }
        }

        return true;
      }

      return false;
    }
  }, {
    key: "moveToBottom",
    value: function moveToBottom() {
      if (Node.prototype.moveToBottom.call(this)) {
        var stage = this.getStage();

        if (stage) {
          var children = stage.children;

          if (stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
          }
        }

        return true;
      }

      return false;
    }
  }, {
    key: "getLayer",
    value: function getLayer() {
      return this;
    }
  }, {
    key: "remove",
    value: function remove() {
      var _canvas = this.getNativeCanvasElement();

      Node.prototype.remove.call(this);

      if (_canvas && _canvas.parentNode && Util._isInDocument(_canvas)) {
        _canvas.parentNode.removeChild(_canvas);
      }

      return this;
    }
  }, {
    key: "getStage",
    value: function getStage() {
      return this.parent;
    }
  }, {
    key: "setSize",
    value: function setSize(_ref) {
      var width = _ref.width,
          height = _ref.height;
      this.canvas.setSize(width, height);
      this.hitCanvas.setSize(width, height);

      this._setSmoothEnabled();

      return this;
    }
  }, {
    key: "_validateAdd",
    value: function _validateAdd(child) {
      var type = child.getType();

      if (type !== 'Group' && type !== 'Shape') {
        Util.throw('You may only add groups and shapes to a layer.');
      }
    }
  }, {
    key: "_toKonvaCanvas",
    value: function _toKonvaCanvas(config) {
      config = config || {};
      config.width = config.width || this.getWidth();
      config.height = config.height || this.getHeight();
      config.x = config.x !== undefined ? config.x : this.x();
      config.y = config.y !== undefined ? config.y : this.y();
      return Node.prototype._toKonvaCanvas.call(this, config);
    }
  }, {
    key: "_checkVisibility",
    value: function _checkVisibility() {
      var visible = this.visible();

      if (visible) {
        this.canvas._canvas.style.display = 'block';
      } else {
        this.canvas._canvas.style.display = 'none';
      }
    }
  }, {
    key: "_setSmoothEnabled",
    value: function _setSmoothEnabled() {
      this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      if (this.parent) {
        return this.parent.width();
      }
    }
  }, {
    key: "setWidth",
    value: function setWidth() {
      Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      if (this.parent) {
        return this.parent.height();
      }
    }
  }, {
    key: "setHeight",
    value: function setHeight() {
      Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
  }, {
    key: "batchDraw",
    value: function batchDraw() {
      var _this2 = this;

      if (!this._waitingForDraw) {
        this._waitingForDraw = true;
        Util.requestAnimFrame(function () {
          _this2.draw();

          _this2._waitingForDraw = false;
        });
      }

      return this;
    }
  }, {
    key: "getIntersection",
    value: function getIntersection(pos) {
      if (!this.isListening() || !this.isVisible()) {
        return null;
      }

      var spiralSearchDistance = 1;
      var continueSearch = false;

      while (true) {
        for (var i = 0; i < INTERSECTION_OFFSETS_LEN; i++) {
          var intersectionOffset = INTERSECTION_OFFSETS[i];

          var obj = this._getIntersection({
            x: pos.x + intersectionOffset.x * spiralSearchDistance,
            y: pos.y + intersectionOffset.y * spiralSearchDistance
          });

          var shape = obj.shape;

          if (shape) {
            return shape;
          }

          continueSearch = !!obj.antialiased;

          if (!obj.antialiased) {
            break;
          }
        }

        if (continueSearch) {
          spiralSearchDistance += 1;
        } else {
          return null;
        }
      }
    }
  }, {
    key: "_getIntersection",
    value: function _getIntersection(pos) {
      var ratio = this.hitCanvas.pixelRatio;
      var p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
      var p3 = p[3];

      if (p3 === 255) {
        var colorKey = Util._rgbToHex(p[0], p[1], p[2]);

        var shape = shapes[HASH + colorKey];

        if (shape) {
          return {
            shape: shape
          };
        }

        return {
          antialiased: true
        };
      } else if (p3 > 0) {
        return {
          antialiased: true
        };
      }

      return {};
    }
  }, {
    key: "drawScene",
    value: function drawScene(can, top) {
      var layer = this.getLayer(),
          canvas = can || layer && layer.getCanvas();

      this._fire(BEFORE_DRAW, {
        node: this
      });

      if (this.clearBeforeDraw()) {
        canvas.getContext().clear();
      }

      Container.prototype.drawScene.call(this, canvas, top);

      this._fire(DRAW, {
        node: this
      });

      return this;
    }
  }, {
    key: "drawHit",
    value: function drawHit(can, top) {
      var layer = this.getLayer(),
          canvas = can || layer && layer.hitCanvas;

      if (layer && layer.clearBeforeDraw()) {
        layer.getHitCanvas().getContext().clear();
      }

      Container.prototype.drawHit.call(this, canvas, top);
      return this;
    }
  }, {
    key: "enableHitGraph",
    value: function enableHitGraph() {
      this.hitGraphEnabled(true);
      return this;
    }
  }, {
    key: "disableHitGraph",
    value: function disableHitGraph() {
      this.hitGraphEnabled(false);
      return this;
    }
  }, {
    key: "setHitGraphEnabled",
    value: function setHitGraphEnabled(val) {
      Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
      this.listening(val);
    }
  }, {
    key: "getHitGraphEnabled",
    value: function getHitGraphEnabled(val) {
      Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
      return this.listening();
    }
  }, {
    key: "toggleHitCanvas",
    value: function toggleHitCanvas() {
      if (!this.parent || !this.parent['content']) {
        return;
      }

      var parent = this.parent;
      var added = !!this.hitCanvas._canvas.parentNode;

      if (added) {
        parent.content.removeChild(this.hitCanvas._canvas);
      } else {
        parent.content.appendChild(this.hitCanvas._canvas);
      }
    }
  }]);

  return Layer;
}(Container);
Layer.prototype.nodeType = 'Layer';

_registerNode(Layer);

Factory.addGetterSetter(Layer, 'imageSmoothingEnabled', true);
Factory.addGetterSetter(Layer, 'clearBeforeDraw', true);
Factory.addGetterSetter(Layer, 'hitGraphEnabled', true, getBooleanValidator());